import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button,Dialog,DialogContent,Stack,Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { trackEventMatomo } from "../../../helpers/matomo";

export default function ModalDelete({
  openDelete,
  setOpenDelete,
  mutate,
  user,
  name
}: {
  openDelete: boolean,
  setOpenDelete: Function,
  mutate: Function,
  user: string,
  name: string
}) {
  const { t } = useTranslation('translation');
  return (
    <Dialog
      fullWidth
      maxWidth={'sm'}
      open={openDelete}
      onClose={() => setOpenDelete(false)}
      scroll={'paper'}
    >
      <DialogContent dividers={true}>
        <Stack direction='column' spacing={2} alignItems='center' justifyContent='center' width='100%' padding={2}>
          <Typography variant="h6" gutterBottom>{t('users.doYouWantToRemoveUser')} <b>{name}</b>?</Typography>
          <Stack direction='row' spacing={2} alignItems='center' justifyContent='space-between' width='100%'>
            <Button
              endIcon={<DeleteIcon />}
              variant='contained'
              color='error'
              onClick={() => {
                trackEventMatomo('modal deleção de usuário', 'click', ' button', 'salva');
                mutate(user);
              }}
            >
              {t('users.remove')}
            </Button>
            <Button
              color='warning'
              endIcon={<CancelIcon />}
              variant='contained'
              onClick={() => {
                trackEventMatomo('modal deleção de usuário', 'click', ' button', 'cancela');
                setOpenDelete();
              }}>
              {t('users.cancel')}
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>

  );
}
